import { ComponentStyleConfig } from '@chakra-ui/react';

export const Modal: ComponentStyleConfig = {
   defaultProps: {
      size: '2xl',
   },
};
